<ng-container [ngSwitch]="isClickable">
  <ng-container *ngSwitchCase="true">
    <button
      class="c-button u-border-grey100"
      [ngStyle]="{ borderRadius: '16px', padding: '6px 12px' }"
      mat-ripple
      [appRippleHover]
      fxLayout="row"
      fxLayoutAlign="start center"
      [nz-tooltip]="toolTipContent"
      [nzTooltipMouseEnterDelay]="0.5"
    >
      <ng-container [ngTemplateOutlet]="baseTemplate"></ng-container>
    </button>
  </ng-container>
  <ng-container *ngSwitchDefault>
    <div
      class="u-border-grey100"
      [ngStyle]="{ borderRadius: '16px', padding: '6px 12px' }"
      fxLayout="row"
      fxLayoutAlign="start center"
      [nz-tooltip]="toolTipContent"
      [nzTooltipMouseEnterDelay]="0.5"
    >
      <ng-container [ngTemplateOutlet]="baseTemplate"></ng-container>
    </div>
  </ng-container>
</ng-container>
<ng-template #baseTemplate>
  <mat-icon
    *ngIf="iconPrefix"
    class="md-18 color-grey-300"
    fxFlex="22px"
    fontSet="material-icons-outlined"
    >{{ iconPrefix }}</mat-icon
  >
  <p
    class="u-textTruncate"
    #textContent
    (cdkObserveContent)="projectContentChanged()"
    [ngStyle]="{ maxWidth: '200px' }"
  >
    <ng-content></ng-content>
  </p>
</ng-template>
